import React, { useState, useEffect } from 'react';
import { Layout, Menu, Dropdown, Space, message } from 'antd';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { userService } from '../services/user.service';
import {
  UserOutlined,
  SettingOutlined,
  TeamOutlined,
  ToolOutlined,
  DownOutlined,
  ApiOutlined,
  GlobalOutlined,
  NodeIndexOutlined
} from '@ant-design/icons';

const { Header, Content, Sider } = Layout;

const menuItems = [
  {
    key: 'tmap',
    icon: <GlobalOutlined />,
    label: '地图大屏',
    path: '/admin/tencentmap'
  },
  //{
  //  key: 'pipemap',
  //  icon: <NodeIndexOutlined />,
  //  label: '管网地图',
  //  path: '/admin/pipemap'
 // },
  {
    key: 'tickets',
    icon: <ToolOutlined />,
    label: '工单管理',
    path: '/admin/tickets'
  },
  {
    key: 'valves',
    icon: <ApiOutlined />,
    label: '阀门管理',
    path: '/admin/valves'
  },
  {
    key: 'users',
    icon: <TeamOutlined />,
    label: '用户管理',
    path: '/admin/users'
  }
];

function AdminLayout() {
  const navigate = useNavigate();
  const location = useLocation();
  const [userInfo, setUserInfo] = useState({ name: '', role: '' });
  
  const verifyUser = async () => {
    const result = await userService.verifyUser();
    if (result.success) {
      setUserInfo(result.data);
    }else {
      handleLogout();
    }
  };

  // 根据当前路径获取选中的菜单项
  const selectedKey = menuItems.find(item => location.pathname.startsWith(item.path))?.key || 'dashboard';

  useEffect(() => {
    verifyUser();
  }, []);

  const handleMenuClick = (item) => {
    const menuItem = menuItems.find(mi => mi.key === item.key);
    if (menuItem) {
      navigate(menuItem.path);
    }
  };

  const handleLogout = async () => {
    await userService.logout();
    navigate('/admin/login');
  };

  const filteredMenuItems = menuItems.filter(item => {
    if (item.key === 'users' && userInfo.type === 1) {
      return false;
    }
    return true;
  });

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Header style={{ 
        padding: '0 24px', 
        background: '#fff', 
        height: '64px', 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'space-between',
        position: 'fixed',
        zIndex: 200,
        width: '100%',
        title: '壹城工程管理系统V1',
        boxShadow: '0 1px 4px rgba(0,21,41,.08)'
      }}>
        <div style={{ 
          color: '#000',
          fontSize: '20px',
          fontWeight: 'bold',
          display: 'flex',
          alignItems: 'center'
        }}>
          <SettingOutlined style={{ marginRight: '12px', fontSize: '24px' }} />
          壹城工程管理系统V1
        </div>
        <Dropdown
          menu={{
            items: [
              { key: 'logout', label: '退出登录', onClick: handleLogout },
            ],
          }}
        >
          <Space style={{ cursor: 'pointer', color: '#595959' }}>
            <UserOutlined style={{ fontSize: '16px' }} />
            <span>{userInfo.name || '未登录'}</span>
            <span style={{ color: '#8c8c8c', marginLeft: '8px' }}>{userInfo.role || '游客'}</span>
            <DownOutlined style={{ fontSize: '12px' }} />
          </Space>
        </Dropdown>
      </Header>
      <Layout style={{ marginTop: '64px' }}>
        <Sider width={200} theme="light" style={{ 
          background: '#f5f5f5',
          position: 'fixed',
          left: 0,
          top: '64px',
          height: 'calc(100vh - 64px)',
          overflowY: 'auto',
          borderRight: '1px solid #f0f0f0'
        }}>
          <Menu
            mode="inline"
            theme="light"
            selectedKeys={[selectedKey]}
            onClick={handleMenuClick}
            items={filteredMenuItems}
            style={{ height: '100%', borderRight: 0 }}
          />
        </Sider>
        <Layout style={{ marginLeft: '200px', padding: '24px' }}>
          <Content style={{ 
            background: '#fff', 
            padding: '12px', 
            margin: 0, 
            borderRadius: '4px',
            minHeight: 280
          }}>
            <Outlet />
          </Content>
        </Layout>
      </Layout>
    </Layout>
  );
}

export default AdminLayout;
